export class AgingSummaryRow {
  public Title: string;
  public AmountDue: number;
  public PercentageDue: number;

  constructor() {
    this.Title = '';
    this.AmountDue = 0;
    this.PercentageDue = 0;
  }
}
